import { render, staticRenderFns } from "./EmployeeCardAvatar.vue?vue&type=template&id=0a795518"
import script from "./EmployeeCardAvatar.vue?vue&type=script&lang=ts"
export * from "./EmployeeCardAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a795518')) {
      api.createRecord('0a795518', component.options)
    } else {
      api.reload('0a795518', component.options)
    }
    module.hot.accept("./EmployeeCardAvatar.vue?vue&type=template&id=0a795518", function () {
      api.rerender('0a795518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/employee/EmployeeCardAvatar.vue"
export default component.exports